import React from 'react'

function SiteName({row , i}) {
  return (
    <>{row?.site?.siteName}</>
  )
}

export default SiteName